import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { map, concatMap, catchError, finalize } from 'rxjs/operators';
import { throwError, Observable, from } from 'rxjs';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpResponse,
} from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { LoaderService } from '@core-services/loader.service';
import { BY_PASS_LOADER } from '@core/permission/permissions.type';
@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService {
  config: any;
  private redirectInFlight = false;
  constructor(
    private msalService: MsalService,
    private router: Router,
    private loaderService: LoaderService
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const config = this.configSet(req);
    const activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount) {
      // MsalService.acquireTokenSilent() throws synchronously (not a
      // rejected promise) when there is no active account, which escapes
      // the catchError below entirely and surfaces as an uncaught
      // "no_account_error". Sign-in is still being completed by
      // AppComponent/MsalGuard at this point, so fail this request
      // cleanly through the Observable error channel instead of crashing.
      this.loaderService.hide();
      return throwError(
        () => new Error('No active MSAL account yet; sign-in in progress')
      );
    }

    return from(
      this.msalService.acquireTokenSilent({
        scopes: config.scopes,
        account: activeAccount,
      })
    )
      .pipe(
        map((token) => {
          const selectedRole = localStorage.getItem('selectedRole');
          req = this.setHeader(req, token);
          if (!this.isPassLoader(req.url)) {
            this.loaderService.show();
          }

          return req;
        }),
        catchError((error: HttpErrorResponse) => {
          this.loaderService.hide();
          // Only force an interactive redirect when we actually have a
          // signed-in account whose silent token acquisition failed (e.g.
          // conditional access / consent). Also guard against firing
          // multiple concurrent redirects when several requests fail at
          // once.
          if (!this.redirectInFlight) {
            this.redirectInFlight = true;
            this.msalService.acquireTokenRedirect(this.config);
          }
          return throwError(() => error);
        })
      )
      .pipe(
        concatMap((request) => {
          return next.handle(request).pipe(
            finalize(() => {
              if (!this.isPassLoader(request.url)) {
                this.loaderService.hide();
              }
            }),
            map((event: HttpEvent<any>) => {
              return event;
            }),
            catchError((error: HttpErrorResponse) => {
              let data = {};
              this.loaderService.hide();
              data = {
                reason: error && error.message ? error.message : '',
                status: error.status,
              };
              if (error.message === 'Authentication failed') {
                localStorage.clear();
                this.msalService.instance.getActiveAccount();
                this.router.navigate(['/']);
              }
              console.log(error);
              return throwError(() => error);
            })
          );
        })
      );
  }
  setHeader(req: HttpRequest<any>, token: any): any {
    if (
      req.url.includes('v1.0/me/photo') ||
      req.url.includes('v1.0/me/memberOf')
    ) {
      req = req.clone({
        setHeaders: {
          Authorization: `${token.accessToken}`,
        },
      });
    } else {
      let appId = localStorage.getItem('selectedApp');
      appId = appId ? appId : '';
      const selectedRole = localStorage.getItem('selectedRole');
      const role = selectedRole ? JSON.parse(selectedRole).meta ?? '' : '';
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token.idToken}`,
          app: appId,
          role,
        },
      });
    }
    return req;
  }

  configSet(req: HttpRequest<any>): any {
    if (
      req.url.includes('v1.0/me/photo') ||
      req.url.includes('v1.0/me/memberOf')
    ) {
      this.config = {
        scopes: ['User.Read'],
      };
    } else {
      this.config = {
        scopes: environment.msalTokenReq?.scopes || ['user.read'],
      };
    }

    return this.config;
  }

  // This method is used for bypassing loader for configured url.
  // @ param : url is current  URI of current http ruqeust.
  isPassLoader(url: string): boolean {
    let isPass = false;
    BY_PASS_LOADER.forEach((v) => {
      if (url.includes(v)) {
        isPass = true;
        return;
      }
    });
    return isPass;
  }
}
